// React
import { createContext } from "react"

export const DataContext = createContext<{
  approve_by: number
}>({
  approve_by: 0
})